/* @ngInject */
function QuoteVersionFactory(QuoteSectionSnapshot, $rootScope, moment) {
  class QuoteVersion {
    constructor(data) {
      this.number = null;
      this.date = null;
      this.expirationDate = null;
      this.status = null;
      this.content = null;
      this.sections = [];
      this.currency = null;
      this.exchangeInfo = null;
      this.signature = null;

      if (data) {
        this.setData(data);
      } else {
        this.number = 1;
        this.date = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
        this.expirationDate = moment()
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .add($rootScope.organization.settings.expirationPeriod, "days")
          .toDate();
        this.status = "none";
        this.currency = $rootScope.organization.settings.currency;
        this.exchangeInfo = $rootScope.organization.exchangeRates;
        this.sections = [new QuoteSectionSnapshot()];
        this.signature = {
          requiredToAccept: $rootScope.organization.settings.signature
            ? $rootScope.organization.settings.signatureDefault
            : false,
          snapshot: $rootScope.organization.settings.signature || undefined,
        };
      }
    }

    setData(data) {
      this._id = data._id ? data._id : undefined;
      this.number = data.number;
      this.date = data.date instanceof Date ? data.date : new Date(data.date);
      this.expirationDate = data.expirationDate instanceof Date ? data.expirationDate : new Date(data.expirationDate);
      this.status = data.status;
      this.content = data.content;
      this.currency = data.currency;
      this.exchangeInfo = data.exchangeInfo;
      this.signature = data.signature;

      if (data.sections) {
        for (let i = 0; i < data.sections.length; i++) {
          if (data.sections[i].sectionType === "pricingTable") {
            data.sections[i].pricingTable.currency = this.currency;
            data.sections[i].pricingTable.exchangeInfo = this.exchangeInfo;
          }
          if (this.sections[i]) this.sections[i].setData(data.sections[i]);
          else this.sections.push(new QuoteSectionSnapshot(data.sections[i], null, this.currency, this.exchangeInfo));
        }

        if (this.sections.length > data.sections.length) {
          this.sections = this.sections.slice(0, data.sections.length);
        }
      } else {
        this.sections = [new QuoteSectionSnapshot(null, null, this.currency, this.exchangeInfo)];
      }
    }

    addSection(index, type, quoteSection) {
      this.sections.splice(
        index + 1,
        0,
        new QuoteSectionSnapshot(quoteSection, type, this.currency, this.exchangeInfo),
      );
    }

    deleteSection(index) {
      this.sections.splice(index, 1);
      if (this.sections.length === 0)
        this.sections.push(new QuoteSectionSnapshot(null, null, this.currency, this.exchangeInfo));
    }

    applyCustomStyleToQuote(index) {
      const style = this.sections[index].style;
      const brandCenterSync = this.sections[index].brandCenterSync;
      this.sections.forEach((section) => {
        section.style.header1 = style.header1;
        section.style.header2 = style.header2;
        section.style.text = style.text;
        section.brandCenterSync = brandCenterSync;
      });
    }

    moveDownSection(index) {
      if (index < this.sections.length - 1) {
        const temp = this.sections[index + 1];
        this.sections[index + 1] = this.sections[index];
        this.sections[index] = temp;
      }
    }

    moveUpSection(index) {
      if (index > 0) {
        const temp = this.sections[index - 1];
        this.sections[index - 1] = this.sections[index];
        this.sections[index] = temp;
      }
    }

    isApproved() {
      return this.status === "approved";
    }

    isRejected() {
      return this.status === "rejected";
    }

    updateCurrency(oldCurrency, newCurrency) {
      this.currency = newCurrency;
      this.sections.forEach((section) => {
        if (section.sectionType === "pricingTable") section.pricingTable.updateCurrency(oldCurrency, newCurrency);
      });
    }

    setExchangeInfo(updatedExchangeInfo) {
      this.exchangeInfo = updatedExchangeInfo;
      this.sections.forEach((section) => {
        if (section.sectionType === "pricingTable") section.pricingTable.exchangeInfo = updatedExchangeInfo;
      });
    }

    getPricingTables() {
      const pricingTablesArray = [];
      this.sections.forEach((section) => {
        if (section.sectionType === "pricingTable") pricingTablesArray.push(section.pricingTable);
      });
      return pricingTablesArray;
    }
  }

  return QuoteVersion;
}

export default QuoteVersionFactory;
